import Button from "@ch/components/Buttons/Button.tsx";
import type { PropsWithChildren } from "react";

const AddNewCard = ({
  onAdd = () => {},
  children,
}: PropsWithChildren<{ onAdd: () => void }>) => {
  return (
    <div className="min-h-[206px] min-w-[206px] divide-y rounded-xl border border-dashed p-4 pt-2">
      <div className="flex h-full w-full flex-col items-center justify-center">
        <Button
          buttonStyle="border rounded-full w-12 mb-2"
          className="rounded-full border text-gray"
          intent="ghost"
          leftIcon="plus"
          onClick={onAdd}
          variant="secondary"
        />
        <p className="text-gray">{children}</p>
      </div>
    </div>
  );
};

export default AddNewCard;
